var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33317 1.33325C9.50998 1.33325 9.67955 1.40349 9.80457 1.52851L13.1379 4.86185C13.2629 4.98687 13.3332 5.15644 13.3332 5.33325V12.6666C13.3332 13.7712 12.4377 14.6666 11.3332 14.6666H4.6665C3.56193 14.6666 2.6665 13.7712 2.6665 12.6666V3.33325C2.6665 2.22868 3.56193 1.33325 4.6665 1.33325H9.33317ZM11.9998 6.66659L7.99984 2.66659L8.00095 6.66659H11.9998Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scanIcon.878a70b7.svg";
export { ForwardRef as ReactComponent };